import  { useState } from 'react'

import useApiResource from 'src/api'

type TaskFnType={
    path:string,payload:Object
}
export const useTask = () => {
const [loading, setLoading] = useState(false)
const [message, setMessage] = useState('')
const apiResource = useApiResource()
const [data, setData] = useState('')

  const taskFn = async({path,payload}:TaskFnType) =>{
    try{
      setLoading(true)
      const {data} = await apiResource({path,method:'post',payload})
      setLoading(false)
      if(data){
        setData(data)
      }
      setMessage('')
    }catch(e){
      console.error('Error onStartTaskFn', e)
      setLoading(false)
      throw new Error(`${e}`)
    }
  }
  return {
    loading,
    setLoading,
    message,
    data,
    taskFn
  }
}
